import React, { useEffect, useState } from "react";
import Icon_L from "../../assets/images/Icon_L.svg";
import { useFormik } from "formik";
import * as Yup from "yup";
import { baseUrl } from "../../utils/baseUrl";
import axios from "axios";
import {
  IAccountMandate,
  ICountry,
  IEmploymentInfo,
  IMeansOfIdentification,
} from "../../models/IEnums.model";
import {
  getLocalStorageItem,
  setLocalStorageItem,
} from "../../utils/localStorage";
import { useDispatch } from "react-redux";
import { setAccountOpeningStep } from "../../redux/accountOpening";
import { formatBVNDate } from "../../utils/formatDate";
import IdCardSample from "../IdCardSample";
import { statesInNigeria } from "../../utils/constants";

function UpdateDetailJointSavingsDialog(props: any) {
  const dispatch = useDispatch();

  const [updating, setUpdating] = useState(false);

  const [meansOfIdentification, setMeansOfIdentification] = useState<
    IMeansOfIdentification[]
  >([]);
  const [employmentInfos, setEmploymentInfos] = useState<IEmploymentInfo[]>([]);
  const [jointAccountMandate, setJointAccountMandate] = useState<
    IAccountMandate[]
  >([]);
  const [countries, setCountries] = useState<ICountry[]>([]);
  const [idCardtype, setIdCardType] = useState<any>(1);
  const [secondaryIdCardtype, setSecondaryIdCardType] = useState<any>(1);

  const [userDetails, setUserDetails] = useState(
    getLocalStorageItem("userDetails")
  );
  const [userNinPayload, setuserNinPayload] = useState(
    getLocalStorageItem("userNinPayload")
  );
  const [todaysDate, setTodaysDate] = useState<any>(
    new Date().toISOString().split("T")[0]
  );

  const goToStep = (step: any) => {
    dispatch(setAccountOpeningStep(step));
  };

  const formik = useFormik({
    initialValues: {
      primaryFirstName: userDetails.firstName,
      primaryMiddleName: userDetails.middleName,
      primaryLastName: userDetails.lastName,
      primaryDob: formatBVNDate(
        userDetails.dateOfBirth ||
          userDetails?.dob ||
          userNinPayload?.dateOfBirth ||
          userNinPayload?.dob
      ),
      primaryIdentityCardType: "",
      primaryIdCardNumber: "",
      primaryIssueDate: "",
      primaryExpiryDate: "",
      primaryEmploymentInformation: "",
      primaryNameOfNextOfKin: "",

      secondaryBvn: "",
      secondaryFirstName: "",
      secondaryMiddleName: "",
      secondaryLastName: "",
      secondaryDob: "",
      secondaryIdentityCardType: "",
      secondaryIdCardNumber: "",
      secondaryIssueDate: "",
      secondaryExpiryDate: "",
      secondaryEmploymentInformation: "",
      secondaryNameOfNextOfKin: "",

      jointAccountName: "",
      jointPhoneNumber: "",
      jointEmailAddress: "",
      jointAccountMandate: "",
      jointOtherMandate: "",

      houseNumber: "",
      streetName: "",
      areaState: "",
      nearestBustopLandmark: "",
      address: "",
      referralCode: "",

      nationality: "",
    },
    validationSchema: Yup.object({
      primaryIdCardNumber: Yup.string().required("ID card number is required"),
      // primaryIssueDate: Yup.string().required("Issue date is required"),
      // primaryExpiryDate: Yup.string().required("Expiry date is required"),

      secondaryBvn: Yup.string().required("BVN is required"),
      secondaryFirstName: Yup.string().required("Firstname is required"),
      secondaryLastName: Yup.string().required("Lastname is required"),
      secondaryDob: Yup.string().required("Date of birth is required"),
      secondaryIdCardNumber: Yup.string().required(
        "ID card number is required"
      ),
      // secondaryIssueDate: Yup.string().required("Issue date is required"),
      // secondaryExpiryDate: Yup.string().required("Expiry date is required"),

      jointAccountName: Yup.string().required("Account Name is required"),
      jointPhoneNumber: Yup.string().required("Phone Number is required"),
      jointEmailAddress: Yup.string()
        .email("Invalid email")
        .required("Email is required"),
      jointAccountMandate: Yup.string().required("Please select a mandate"),

      address: Yup.string().required("Address is required"),
      nationality: Yup.string().required("Nationality is required"),
    }),
    onSubmit: (values) => {
      updateDetails(values);
    },
  });

  const updateDetails = (values: any) => {
    let updateDetailsPayload = {
      ...values,
      primaryIdentityCardType: +idCardtype,
      secondaryIdentityCardType: +secondaryIdCardtype,
      jointAccountMandate: +values.jointAccountMandate,
      bvn: userDetails.bvn,
    };
    
    setLocalStorageItem(
      "update-details-page-user-data",
      JSON.stringify(updateDetailsPayload)
    );
    // return
    setUpdating(true);
    axios
      .post(`${baseUrl}JointSavings/Details`, updateDetailsPayload)
      .then((response) => {
        
        setUpdating(false);
        dispatch(setAccountOpeningStep("document-upload"));
      })
      .catch((err) => {
        
        setUpdating(false);
      });
  };

  const getEmploymentInfo = () => {
    axios
      .get(`${baseUrl}Enum/EmployementInfo`)
      .then((response) => {
        setEmploymentInfos(response.data);
      })
      .catch((err) => {
        
      });
  };

  const getMeansOfIdentification = () => {
    axios
      .get(`${baseUrl}Enum/MeansOfIdentification`)
      .then((response) => {
        setMeansOfIdentification(response.data);
      })
      .catch((err) => {
        
      });
  };

  const getJointAccountMandates = () => {
    axios
      .get(`${baseUrl}Enum/JointAccountMandate`)
      .then((response) => {
        setJointAccountMandate(response.data);
      })
      .catch((err) => {
        
      });
  };

  const getCountries = () => {
    axios
      .get(`${baseUrl}Enum/Country`)
      .then((response) => {
        let nigeria = response?.data.find(
          (x) => x.lonG_DESC_ENG.toLowerCase() === "nigeria"
        );
        let otherCountries = response?.data.filter(
          (x) => x.lonG_DESC_ENG.toLowerCase() !== "nigeria"
        );
        let countries = [nigeria, ...otherCountries];
        setCountries(countries);
      })
      .catch((err) => {
        
      });
  };

  const handleSetIdCardType = (id: any) => {
    setIdCardType(id);
  };

  const handleSetSecondaryIdCardType = (id: any) => {
    setSecondaryIdCardType(id);
  };

  useEffect(() => {
    getMeansOfIdentification();
    getEmploymentInfo();
    getJointAccountMandates();
    getCountries();
  }, []);

  const handleKeyPress = (event) => {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      event.preventDefault(); // Prevent input of non-numeric characters
    }
  };

  return (
    <div>
      <form onSubmit={formik.handleSubmit}>
        <div className="card-body">
          <h4 className="card-title text-center pl-3 mt-4">Update details</h4>
          <p className="text-center pl-5 no-wrap">
            Hello{" "}
            <span className="font-weight-bold">
              <b>{userDetails.firstName},</b>{" "}
            </span>
            Welcome to Sterling Alternative Finance
          </p>
          <div className="bvn_val mb-4" id="fader">
            <img src={Icon_L} alt="" />
            <small className="text-danger ml-4 font-weight-bold">
              <b>Update your address and email if it has changed</b>
            </small>
          </div>
          <div className="row">
            <div className="col-sm-4 mt-4">
              <small className="label_text">First signatory</small>
              <div className="col-12 pic_upload3 label_text3 text-nowrap">
                Photo
              </div>
            </div>

            <div className="col-sm-8 mt-4 pt-2 sec">
              <div className="row form-row mb-3">
                <div className="col-lg-6 sec">
                  <label htmlFor="firstname" className="label_text">
                    Firstname
                  </label>
                  <input
                    name="firstName"
                    value={userDetails.firstName}
                    type="text"
                    className="form-control bg-white border-dark"
                    placeholder="Tunde"
                    disabled
                  />
                </div>
                <div className="col-lg-6">
                  <label htmlFor="secondname" className="label_text">
                    Secondname
                  </label>
                  <input
                    name="secondName"
                    value={userDetails.middleName}
                    type="text"
                    className="form-control bg-white border-dark"
                    placeholder="Emeka"
                    disabled
                  />
                </div>
              </div>
              <div className="row form-row mb-3">
                <div className="col-lg-6">
                  <label htmlFor="lastname" className="label_text">
                    Lastname
                  </label>
                  <input
                    name="lastName"
                    value={userDetails.lastName}
                    type="text"
                    className="form-control bg-white border-dark"
                    placeholder="Aminah"
                    disabled
                  />
                </div>
                <div className="col-lg-6">
                  <label htmlFor="dateofbirth" className="label_text">
                    Date of birth
                  </label>
                  <input
                    name="dob"
                    max={todaysDate}
                    value={userDetails.dateOfBirth}
                    type="text"
                    className="form-control bg-white border-dark"
                    placeholder="12-04-1989"
                    disabled
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="form-group">
            <label htmlFor="idcardtype" className="label_text my-2">
              Select identity card type
            </label>

            <ul
              className="nav nav-pills identity-tab mb-3 nav-fill"
              id="pills-tab"
              role="tablist"
            >
              {meansOfIdentification.map(
                (identification: IMeansOfIdentification) => {
                  return (
                    <li
                      className="nav-item"
                      key={identification.id}
                      onClick={() => handleSetIdCardType(identification.id)}
                    >
                      <a
                        className={`nav-link text-nowrap pl-0 pt-2 ${
                          identification.id == 1 ? "active" : ""
                        }`}
                        id="pills-int-tab"
                        data-toggle="pill"
                        href="#pills-int"
                        role="tab"
                        aria-controls="pills-int"
                        aria-selected="true"
                      >
                        {identification.text}
                      </a>
                    </li>
                  );
                }
              )}
            </ul>
            <div className="tab-content" id="pills-tabContent">
              <div
                className="tab-pane show fade active"
                id="pills-int"
                role="tabpanel"
                aria-labelledby="pills-int-tab"
              >
                <div className="row mb-4">
                  <div className="col-md-6">
                    <div className="form-group">
                      <label
                        htmlFor="nextofkin"
                        className="label_text mb-2"
                        data-bs-toggle="modal"
                        data-bs-target="#idCardSampleModal"
                      >
                        ID card number{" "}
                        <i className="bx bxs-info-circle cursor-pointer"></i>
                      </label>
                      <input
                        name="primaryIdCardNumber"
                        onChange={formik.handleChange}
                        value={formik.values.primaryIdCardNumber}
                        className="form-control border-dark"
                        type="text"
                        id="name"
                        placeholder="Enter ID card number"
                      />
                      {formik.touched.primaryIdCardNumber &&
                      formik.errors.primaryIdCardNumber ? (
                        <small className="text-danger">
                          {formik.errors.primaryIdCardNumber}
                        </small>
                      ) : null}
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="form-group identity">
                      <label htmlFor="issuedate" className="label_text mb-2">
                        Issue Date
                      </label>
                      <input
                        name="primaryIssueDate"
                        max={todaysDate}
                        onChange={formik.handleChange}
                        value={formik.values.primaryIssueDate}
                        type="date"
                        className="form-control border-dark bg-white"
                        placeholder="dd/mm/yyyy"
                      />
                      {/* {formik.touched.primaryIssueDate && formik.errors.primaryIssueDate ? <small className="text-danger">{formik.errors.primaryIssueDate}</small> : null} */}
                    </div>
                  </div>

                  {(idCardtype == 2 || idCardtype == 4) && (
                    <div className="col-md-3">
                      <div className="form-group">
                        <label htmlFor="expirydate" className="label_text mb-2">
                          Expiry Date
                        </label>
                        <input
                          name="primaryExpiryDate"
                          min={todaysDate}
                          onChange={formik.handleChange}
                          value={formik.values.primaryExpiryDate}
                          type="date"
                          className="form-control border-dark bg-white"
                          placeholder="dd/mm/yyyy"
                        />
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col sec">
              <div className="row form-row mb-3">
                <div className="col-lg-6 mr-2">
                  <label htmlFor="nextofkin" className="label_text">
                    Name of next of kin
                  </label>
                  <input
                    name="primaryNameOfNextOfKin"
                    onChange={formik.handleChange}
                    value={formik.values.primaryNameOfNextOfKin}
                    type="text"
                    className="form-control bg-white border-dark"
                    placeholder="Enter name of next of kin"
                  />
                </div>
                <div className="col-lg-6 form-group">
                  <label htmlFor="employmentinformation" className="label_text">
                    Select employment information
                  </label>
                  <select
                    name="primaryEmploymentInformation"
                    onChange={formik.handleChange}
                    value={formik.values.primaryEmploymentInformation}
                    onBlur={formik.handleBlur}
                    className="form-control select-group border-dark bg-white select-dropdown pt-2 pb-3"
                    id="box"
                  >
                    <option value="">Select employment information</option>
                    {employmentInfos.map((employmentInfo: IEmploymentInfo) => {
                      return (
                        <option
                          key={employmentInfo.id}
                          value={employmentInfo.id}
                        >
                          {employmentInfo.name}
                        </option>
                      );
                    })}
                  </select>
                </div>
              </div>
            </div>
          </div>

          <div className="row mt-3 mb-4">
            <div className="col form-group">
              <label htmlFor="nationality" className="label_text">
                Nationality
              </label>
              <select
                name="nationality"
                onChange={formik.handleChange}
                value={formik.values.nationality}
                className="form-control border-dark"
              >
                <option value="">Select nationality</option>
                {countries.map((country: ICountry) => {
                  return (
                    <option key={country.id} value={country.countrY_CODE}>
                      {country.lonG_DESC_ENG}
                    </option>
                  );
                })}
              </select>
              {formik.touched.nationality && formik.errors.nationality ? (
                <small className="text-danger">
                  {formik.errors.nationality}
                </small>
              ) : null}
            </div>
          </div>

          <div className="form-group mt-4 mb-4">
            <label
              htmlFor="idcardtype"
              className="label_text font-weight-bold mb-3"
            >
              <b>Second signatory</b>
            </label>
            <div className="d-flex justify-content-between pb-1 fillup">
              <label htmlFor="name" className="fila">
                Enter BVN (of secondary signatory)
              </label>
              <i
                className="bx bxs-info-circle"
                data-toggle="tooltip"
                data-placement="bottom"
                title="The Bank Verification Number (BVN) is an 11-digit number.Dial *565*0# to check your BVN"
              ></i>
            </div>
            <input
              name="secondaryBvn"
              onChange={formik.handleChange}
              value={formik.values.secondaryBvn}
              className="form-control bvn_input text-muted border-dark"
              type="text"
              id="bvn /"
              placeholder="Enter your BVN"
            />
            {formik.touched.secondaryBvn && formik.errors.secondaryBvn ? (
              <small className="text-danger">
                {formik.errors.secondaryBvn}
              </small>
            ) : null}
          </div>

          <div className="row">
            <div className="col-sm-4 mt-4">
              <br />
              <div className="col-12 pic_upload3 label_text3 text-nowrap">
                Photo
              </div>
            </div>

            <div className="col-sm-8 mt-4 pt-2 sec">
              <div className="row form-row mb-3">
                <div className="col-lg-6 sec">
                  <label htmlFor="firstname" className="label_text">
                    Firstname
                  </label>
                  <input
                    name="secondaryFirstName"
                    onChange={formik.handleChange}
                    value={formik.values.secondaryFirstName}
                    type="text"
                    className="form-control bg-white border-dark"
                    placeholder=""
                  />
                  {formik.touched.secondaryFirstName &&
                  formik.errors.secondaryFirstName ? (
                    <small className="text-danger">
                      {formik.errors.secondaryFirstName}
                    </small>
                  ) : null}
                </div>
                <div className="col-lg-6">
                  <label htmlFor="secondname" className="label_text">
                    Secondname
                  </label>
                  <input
                    name="secondaryMiddleName"
                    onChange={formik.handleChange}
                    value={formik.values.secondaryMiddleName}
                    type="text"
                    className="form-control bg-white border-dark"
                    placeholder=""
                  />
                  {formik.touched.secondaryMiddleName &&
                  formik.errors.secondaryMiddleName ? (
                    <small className="text-danger">
                      {formik.errors.secondaryMiddleName}
                    </small>
                  ) : null}
                </div>
              </div>
              <div className="row form-row mb-3">
                <div className="col-lg-6">
                  <label htmlFor="lastname" className="label_text">
                    Lastname
                  </label>
                  <input
                    name="secondaryLastName"
                    onChange={formik.handleChange}
                    value={formik.values.secondaryLastName}
                    type="text"
                    className="form-control bg-white border-dark"
                    placeholder=""
                  />
                  {formik.touched.secondaryLastName &&
                  formik.errors.secondaryLastName ? (
                    <small className="text-danger">
                      {formik.errors.secondaryLastName}
                    </small>
                  ) : null}
                </div>
                <div className="col-lg-6">
                  <label htmlFor="dateofbirth" className="label_text">
                    Date of birth
                  </label>
                  <input
                    name="secondaryDob"
                    max={todaysDate}
                    onChange={formik.handleChange}
                    value={formik.values.secondaryDob}
                    type="date"
                    className="form-control bg-white border-dark"
                    placeholder=""
                  />
                  {formik.touched.secondaryDob && formik.errors.secondaryDob ? (
                    <small className="text-danger">
                      {formik.errors.secondaryDob}
                    </small>
                  ) : null}
                </div>
              </div>
            </div>
          </div>

          <div className="form-group">
            <label htmlFor="idcardtype" className="label_text mb-3">
              Select identity card type
            </label>

            <ul
              className="nav nav-pills identity-tab mb-3 nav-fill"
              id="pills-tab"
              role="tablist"
            >
              {meansOfIdentification.map(
                (identification: IMeansOfIdentification) => {
                  return (
                    <li
                      className="nav-item"
                      key={identification.id}
                      onClick={() =>
                        handleSetSecondaryIdCardType(identification.id)
                      }
                    >
                      <a
                        className={`nav-link text-nowrap pl-0 pt-2 ${
                          identification.id == 1 ? "active" : ""
                        }`}
                        id="pills-int-tab"
                        data-toggle="pill"
                        href="#pills-int"
                        role="tab"
                        aria-controls="pills-int"
                        aria-selected="true"
                      >
                        {identification.text}
                      </a>
                    </li>
                  );
                }
              )}
            </ul>
            <div className="tab-content" id="pills-tabContent">
              <div
                className="tab-pane show fade active"
                id="pills-int2"
                role="tabpanel"
                aria-labelledby="pills-int-tab"
              >
                <div className="row mb-4">
                  <div className="col-md-6">
                    <div className="form-group">
                      <label
                        htmlFor="nextofkin"
                        className="label_text mb-2"
                        data-bs-toggle="modal"
                        data-bs-target="#idCardSampleModal"
                      >
                        ID card number{" "}
                        <i className="bx bxs-info-circle cursor-pointer"></i>
                      </label>
                      <input
                        name="secondaryIdCardNumber"
                        onChange={formik.handleChange}
                        value={formik.values.secondaryIdCardNumber}
                        className="form-control border-dark"
                        type="text"
                        id="name"
                        placeholder="Enter ID card number"
                      />
                      {formik.touched.secondaryIdCardNumber &&
                      formik.errors.secondaryIdCardNumber ? (
                        <small className="text-danger">
                          {formik.errors.secondaryIdCardNumber}
                        </small>
                      ) : null}
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="form-group identity">
                      <label htmlFor="issuedate" className="label_text mb-2">
                        Issue Date
                      </label>
                      <input
                        name="secondaryIssueDate"
                        max={todaysDate}
                        onChange={formik.handleChange}
                        value={formik.values.secondaryIssueDate}
                        type="date"
                        className="form-control border-dark bg-white"
                        placeholder="dd/mm/yyyy"
                      />
                      {/* {formik.touched.secondaryIssueDate && formik.errors.secondaryIssueDate ? <small className="text-danger">{formik.errors.secondaryIssueDate}</small> : null} */}
                    </div>
                  </div>

                  {(secondaryIdCardtype == 2 || secondaryIdCardtype == 4) && (
                    <div className="col-md-3">
                      <div className="form-group">
                        <label htmlFor="expirydate" className="label_text mb-2">
                          Expiry Date
                        </label>
                        <input
                          name="secondaryExpiryDate"
                          min={todaysDate}
                          onChange={formik.handleChange}
                          value={formik.values.secondaryExpiryDate}
                          type="date"
                          className="form-control border-dark bg-white"
                          placeholder="dd/mm/yyyy"
                        />
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col sec">
              <div className="row form-row mb-3">
                <div className="col-lg-6 mr-2">
                  <label htmlFor="nextofkin" className="label_text">
                    Name of next of kin
                  </label>
                  <input
                    name="secondaryNameOfNextOfKin"
                    onChange={formik.handleChange}
                    value={formik.values.secondaryNameOfNextOfKin}
                    type="text"
                    className="form-control bg-white border-dark"
                    placeholder="Enter name of next of kin"
                  />
                </div>
                <div className="col-lg-6 form-group">
                  <label
                    htmlFor="employmentinformation"
                    className="label_text text-nowrap"
                  >
                    Select employment information
                  </label>
                  <select
                    name="secondaryEmploymentInformation"
                    onChange={formik.handleChange}
                    value={formik.values.secondaryEmploymentInformation}
                    onBlur={formik.handleBlur}
                    className="form-control select-group border-dark bg-white select-dropdown pt-2 pb-3"
                    id="box"
                  >
                    <option value="">Select employment information</option>
                    {employmentInfos.map((employmentInfo: IEmploymentInfo) => {
                      return (
                        <option
                          key={employmentInfo.id}
                          value={employmentInfo.id}
                        >
                          {employmentInfo.name}
                        </option>
                      );
                    })}
                  </select>
                </div>
              </div>
            </div>
          </div>

          <div className="form-group mt-4 mb-4">
            <label
              htmlFor="idcardtype"
              className="label_text font-weight-bold mb-3"
            >
              <b>Joint account information</b>
            </label>
            <div className="d-flex justify-content-between pb-2 fillup">
              <label htmlFor="name" className="label_text pb-1">
                Joint account name
              </label>
            </div>
            <input
              name="jointAccountName"
              onChange={formik.handleChange}
              value={formik.values.jointAccountName}
              className="form-control bvn_input text-muted border-dark"
              type="text"
              id="bvn"
              placeholder=""
            />
            {formik.touched.jointAccountName &&
            formik.errors.jointAccountName ? (
              <small className="text-danger">
                {formik.errors.jointAccountName}
              </small>
            ) : null}
          </div>

          <div className="row">
            <div className="col sec">
              <div className="row form-row mb-3">
                <div className="col-lg-6 mr-2">
                  <label htmlFor="phonenumber" className="label_text">
                    Joint account phone number
                  </label>
                  <input
                    name="jointPhoneNumber"
                    onChange={formik.handleChange}
                    value={formik.values.jointPhoneNumber}
                    type="text"
                    className="form-control border-dark bg-white"
                    placeholder="0801 2345 678"
                  />
                  {formik.touched.jointPhoneNumber &&
                  formik.errors.jointPhoneNumber ? (
                    <small className="text-danger">
                      {formik.errors.jointPhoneNumber}
                    </small>
                  ) : null}
                </div>
                <div className="col-lg-6">
                  <label htmlFor="email" className="label_text">
                    {" "}
                    Joint account email address
                  </label>
                  <input
                    name="jointEmailAddress"
                    onChange={formik.handleChange}
                    value={formik.values.jointEmailAddress}
                    type="email"
                    className="form-control bg-white border-dark"
                    placeholder=""
                  />
                  {formik.touched.jointEmailAddress &&
                  formik.errors.jointEmailAddress ? (
                    <small className="text-danger">
                      {formik.errors.jointEmailAddress}
                    </small>
                  ) : null}
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col sec">
              <div className="row form-row mb-2">
                <div className="col-lg-6 form-group mr-2">
                  <label htmlFor="employmentinformation" className="label_text">
                    Select joint account mandate
                  </label>
                  <select
                    name="jointAccountMandate"
                    onChange={formik.handleChange}
                    value={formik.values.jointAccountMandate}
                    onBlur={formik.handleBlur}
                    className="form-control select-group border-dark bg-white select-dropdown pt-2 pb-3"
                    id="box"
                  >
                    <option value="">Select mandate</option>
                    {jointAccountMandate.map((mandate: IAccountMandate) => {
                      return (
                        <option key={mandate.id} value={mandate.id}>
                          {mandate.mandate}
                        </option>
                      );
                    })}
                  </select>
                  {formik.touched.jointAccountMandate &&
                  formik.errors.jointAccountMandate ? (
                    <small className="text-danger">
                      {formik.errors.jointAccountMandate}
                    </small>
                  ) : null}
                </div>
                <div className="col-lg-6">
                  <label htmlFor="specifymandate" className="label_text">
                    Specify Mandate (for others)
                  </label>
                  <input
                    name="jointOtherMandate"
                    onChange={formik.handleChange}
                    value={formik.values.jointOtherMandate}
                    type="text"
                    className="form-control bg-white border-dark"
                    placeholder=""
                  />
                </div>
              </div>
            </div>
          </div>

          <label
            htmlFor="residentialaddress"
            className="label_text mb-2 mt-4 font-weight-bold"
          >
            <b>Residential address</b>
          </label>

          <div className="row">
            <div className="col sec">
              <div className="row form-row mb-3">
                <div className="col-lg-6 mr-2">
                  <label htmlFor="housenumber" className="label_text">
                    House number
                  </label>
                  <input
                    name="houseNumber"
                    onChange={formik.handleChange}
                    value={formik.values.houseNumber}
                    type="text"
                    onKeyPress={handleKeyPress}
                    className="form-control bg-white border-dark"
                    placeholder="eg. 12"
                    pattern="[0-9]*" // This pattern allows only numeric characters
                  />
                </div>
                <div className="col-lg-6">
                  <label htmlFor="streetname" className="label_text">
                    Street name
                  </label>
                  <input
                    name="streetName"
                    onChange={formik.handleChange}
                    value={formik.values.streetName}
                    type="text"
                    className="form-control bg-white border-dark"
                    placeholder="Bode Thomas"
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="row mb-4">
            <div className="col sec">
              <div className="row form-row mb-3">
                <div className="col-lg-6 mr-2">
                  <label htmlFor="housenumber" className="label_text">
                    Area/State
                  </label>
                  <select
                    name="areaState"
                    onChange={formik.handleChange}
                    value={formik.values.areaState}
                    className="form-control border-dark"
                    style={{
                      padding: "13px",
                    }}
                  >
                    <option value="">Select state</option>
                    {statesInNigeria.map((state: any) => {
                      return (
                        <option key={state.name} value={state.name}>
                          {state.name}
                        </option>
                      );
                    })}
                  </select>
                </div>
                <div className="col-lg-6">
                  <label htmlFor="streetname" className="label_text">
                    Nearest bus-top/landmark
                  </label>
                  <input
                    name="nearestBustopLandmark"
                    onChange={formik.handleChange}
                    value={formik.values.nearestBustopLandmark}
                    type="text"
                    className="form-control bg-white border-dark"
                    placeholder="Masha round about"
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="form-group mb-4">
            <label htmlFor="address" className="label_text">
              Address
            </label>
            <input
              name="address"
              onChange={formik.handleChange}
              value={formik.values.address}
              className="form-control sec border-dark"
              type="text"
              id="address"
              placeholder="No 12 Bode Thomas Masha round about Lagos"
            />
            {formik.touched.address && formik.errors.address ? (
              <small className="text-danger">{formik.errors.address}</small>
            ) : null}
          </div>

          <div className="form-group">
            <label htmlFor="refferalcode" className="label_text">
              DAO/Referral code(optional)
            </label>
            <input
              name="referralCode"
              onChange={formik.handleChange}
              value={formik.values.referralCode}
              className="form-control border-dark"
              type="text"
              id="name"
              placeholder="Enter referral code"
            />
          </div>

          <div className="d-flex justify-content-end mt-4">
            <button
              onClick={() => {
                goToStep("bvn-validation");
              }}
              style={{ marginRight: "10px" }}
              className="btn btn-outline-danger mr-3 btn-filled-white"
            >
              Previous
            </button>
            {updating ? (
              <div className="spinner-border text-danger" role="status">
                <span className="sr-only"></span>
              </div>
            ) : (
              <button type="submit" className="btn btn-danger btn-filled-red">
                Proceed
              </button>
            )}
          </div>
        </div>
      </form>

      {/*  */}
      <div
        className="modal fade"
        id="idCardSampleModal"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <IdCardSample idCardType={idCardtype} />
            </div>
          </div>
        </div>
      </div>
      {/*  */}
    </div>
  );
}

export default UpdateDetailJointSavingsDialog;
